import React from 'react';
import { text } from 'stream/consumers';
import Faqs from '../Contact/Faqs';
const textData = [
  {
    'How many people can participate in your private tours?':
      'Our private tours are designed for intimate experiences and can accommodate up to seven people. This ensures personalized attention and a close-knit atmosphere.'
  },
  {
    ' Is there an additional cost per person if the group size increases?':
      'The additional cost per person may vary depending on the specific private tour you choose. To find out the exact pricing for your desired tour, please visit the tour page and select your preferred tour package.'
  },
  {
    'Can you customize a private tour to my interests?':
      'Absolutely! Our private tours are tailored to your interests and preferences. Feel free to let us know your preferences and our knowledgeable guides will create a personalized experience for you. '
  },
  {
    'Are all attraction admissions included in the private tour price? ':
      "Yes, the private tour price includes admission to all attractions, taxes, and fees. You won't need to worry about purchasing tickets separately or waiting in lines. "
  },
  {
    'How do I book a private tour with See Sight Tours?':
      'Booking a private tour with us is easy. Simply visit the tour page of your chosen destination, select your preferred tour package, and follow the booking instructions. You can also reach out to us at Info@seesight-tours.com or call us at 1-888-961-6584 (Toll Free) for assistance. '
  },
  {
    'Can I get picked up and dropped off at my downtown hotel?':
      "Yes, we offer complimentary private pick-up and drop-off services at downtown hotels for your convenience. Just let us know your hotel details when booking, and we'll make the necessary arrangements."
  },
  {
    'Where can I find more information about the private tours available?':
      "To explore our range of private tours and get detailed information about each tour, please visit our Private Tours page. You'll find your descriptions, pricing, and booking options.."
  },
  {
    'Do you offer private tours in locations other than the ones listed on your website?':
      "While our website showcases our primary tour destinations, we may have additional offerings in other locations. If you have a specific location in mind, please contact us, and we'll be happy to discuss the possibilities."
  },
  {
    'How experienced are your tour guides?':
      'Our tour guides are local experts with in-depth knowledge of the attractions and destinations they guide you through. They are passionate about sharing the unique stories and insights of each location to enhance your tour experience.'
  },
  {
    'Can I request specific stops or attractions during a private tour?':
      "Absolutely! We welcome your input and can accommodate special requests for stops or attractions you'd like to include in your private tour. Just let us know your preferences when booking, and we'll make it happen."
  }
];
const FaqPrivate = () => {
  return (
    <div className="w-full flex justify-center my-6 ">
      <div className=" w-[90%] lg:w-[80%] 3xl:w-[70%]  max-w-[1750px] flex justify-center ">
        <Faqs
          header="Frequently Asked Questions"
          subHeader=""
          content={textData}
          contact={true}
        />
      </div>
    </div>
  );
};

export default FaqPrivate;
